/**
 * PDP sale badge — only show it while a variant that is actually on sale is selected.
 *
 * snippets/product-badges.liquid renders the badge (hidden) whenever the product
 * has at least one on-sale variant, so this only has to reveal/hide it as the
 * shopper switches variants. The theme itself never touched the badge — the
 * product-level compare_at_price meant it stayed visible on non-sale variants.
 *
 * Uses the theme's `product:variant-change` DOM event, which is gated behind
 * window.flu.states.useCustomEvents (enabled in snippets/theme-globals.liquid).
 *
 * The theme dispatches that event on `document` and the payload is just the
 * variant — no product reference — so a quick view opened over a PDP would
 * otherwise retag the PDP's badge. Each badge therefore carries its own
 * product's variant ids and ignores events for variants it doesn't own.
 */
(function () {
  "use strict";

  function idList(el, attribute) {
    var raw = el.getAttribute(attribute) || "";
    return raw.split(",").filter(Boolean);
  }

  function syncSaleBadges(variant) {
    // A null variant means the picker sits on an unavailable option combination.
    // There is no id to scope by then, so leave every badge alone rather than
    // risk hiding one that belongs to a different product on the same page.
    if (!variant || variant.id === null || variant.id === undefined) return;

    var badges = document.querySelectorAll("[data-pa-sale-badge]");
    var id = String(variant.id);

    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      if (idList(badge, "data-pa-badge-variants").indexOf(id) === -1) continue;

      if (idList(badge, "data-pa-badge-sale-variants").indexOf(id) === -1) {
        badge.setAttribute("hidden", "");
      } else {
        badge.removeAttribute("hidden");
      }
    }
  }

  document.addEventListener("product:variant-change", function (event) {
    syncSaleBadges(event && event.detail ? event.detail.variant : null);
  });
})();
